import { render, staticRenderFns } from "./RTPList.vue?vue&type=template&id=2b4c74c5&"
import script from "./RTPList.vue?vue&type=script&lang=js&"
export * from "./RTPList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b4c74c5')) {
      api.createRecord('2b4c74c5', component.options)
    } else {
      api.reload('2b4c74c5', component.options)
    }
    module.hot.accept("./RTPList.vue?vue&type=template&id=2b4c74c5&", function () {
      api.rerender('2b4c74c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/RTPList.vue"
export default component.exports